module.exports = __webpack_public_path__ + "548f5a774f75d0d2134c97883c230456.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/verrat_unclear.svg
// module id = 67
// module chunks = 0